export enum ApiVersionsEnum {
    V1 = 'v1',
    V1_1 = 'v1.1',
    V1_2 = 'v1.2',
    V2 = 'v2',
    V3 = 'v3',
}